import React from "react";
import useForm from "./index";
import Label from "./label";
import { TData, TForm, TInputElementProps, TInputProps } from "@/components/form/types";
import Tooltip from "@/components/tooltip";

export const ToggleInput = ({ container, label, input, tooltip, className, hidden, options }: TInputElementProps<TToggleInput>) => {
    const click = (id: string) => {
        const element = document.getElementById(id);
        if (element) element.click();
    }

    if (hidden) {
        return null;
    }

    if (options?.data) {
        return (
            <div {...container} className={container?.className ?? className}>
                <Label {...label} tooltip={tooltip} options={options}/>
                <div className="group--flex gg-3">
                    { options?.data?.map?.((item: TData, index: number) => {
                        const { value, label, tooltip } = item;
                        const isChecked = input.value.toString().split(",").includes(value);

                        return (
                            <div className="form__radio" key={index} onClick={() => click(input.id + index)}>
                                {/*<input {...input} id={input.id + index}/>*/}
                                <input {...input} id={input.id + index} value={value} checked={isChecked}/>
                                <Label id={input.id + index} label={label} type="inline" options={options}/>
                                { tooltip && <Tooltip>{tooltip}</Tooltip> }
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <div {...container} className={container?.className ?? className}>
            {/*// @ts-ignore*/}
            <input {...input}/>
            <Label {...label} type="inline" options={options}/>
        </div>
    );
};

type TToggleInput = boolean;
const useToggleInput = <T extends TToggleInput>(props: TInputProps<T>): TForm<TToggleInput> => {
    const form = useForm<TToggleInput>({
        id: "toggle",
        type: "checkbox",
        default: false,
        ...props,
    })

    return {
        ...form,
    }
}

export default useToggleInput;
